import {useMutation, useQuery} from "@tanstack/react-query";
import {resetAuthState, trpc} from "@/app/trpc";

export const useAuth = () => {
  const {data: user, isLoading} = useQuery({
    ...trpc.auth.me.queryOptions(),
    retry: false,
    staleTime: Infinity,
    refetchInterval: 60_000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: "always",
  });

  return {
    user,
    isLoading,
    isAuthenticated: Boolean(user),
  };
};

export const useLogout = () => {
  return useMutation({
    ...trpc.auth.logout.mutationOptions(),
    onSuccess: () => {
      resetAuthState();
    },
  });
};
